import { LocalTime } from "@js-joda/core";
import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, textBox, timeBox } from "trader.ts/ui.forms";
import { renderSaveButton } from "../../client/savebutton";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";
import * as FA from "../../../styles/fontawesome.css.classes";
import { mandatoryValidation } from "../../lib/validate";

export function render(opts: {
  schoolname: string;
  generalemail: string | null;
  schoolaccount: string | null;
  termsurl: string | null;
  schoolhours: [LocalTime, LocalTime];
  invoicedetails: {
    vat: string | null;
    address: string | null;
    extra: string | null;
  };
}): HTMLElement | HTMLElement[] {
  const form = new Form({})
    .addField("schoolname", [], () =>
      textBox({
        initialVal: opts.schoolname,
        label: "Schoolnaam",
        validations: [mandatoryValidation],
      }),
    )
    .addField("generalemail", [], () =>
      textBox({
        validations: [mandatoryValidation],
        initialVal: opts.generalemail || "",
        label: "Algemeen emailadres",
      }),
    )
    .addField("schoolaccount", [], () =>
      textBox({
        validations: [mandatoryValidation],
        initialVal: opts.schoolaccount || "",
        label: "Rekeningnummer",
      }),
    )
    .addField("termsurl", [], () =>
      textBox({
        initialVal: opts.termsurl || "",
        label: "Link naar schoolreglement",
      }),
    )
    .addField("schoolhours_start", [], () =>
      timeBox({
        initialVal: opts.schoolhours[0],
      }),
    )
    .addField("schoolhours_end", [], () =>
      timeBox({
        initialVal: opts.schoolhours[1],
      }),
    )
    .addField("invoicedetails_vat", [], () =>
      textBox({
        label: "Factuurinfo: BTW nummer, bedrijfsnummer, ...",
        initialVal: opts.invoicedetails.vat || "",
        type: "textarea",
      }),
    )
    .addField("invoicedetails_address", [], () =>
      textBox({
        label: "Factuurinfo: Adres",
        initialVal: opts.invoicedetails.address || "",
        type: "textarea",
      }),
    )
    .addField("invoicedetails_extra", [], () =>
      textBox({
        label: "Factuurinfo: Extra",
        initialVal: opts.invoicedetails.extra || "",
        type: "textarea",
      }),
    )
    .build({
      render: (fields) => (
        <div>
          <div className={style.equal_columns}>
            {fields.schoolname()}
            {fields.generalemail()}
          </div>

          <div className={style.equal_columns}>
            {fields.schoolaccount()}
            {fields.termsurl()}
          </div>

          <label for="">{"Schooluren"}</label>
          <div className={style.equal_columns}>
            <div className={style.equal_columns_non_responsive}>
              {fields.schoolhours_start()}
              {fields.schoolhours_end()}
            </div>
            <div></div>
          </div>

          <div className={style.equal_columns}>
            {fields.invoicedetails_vat()}
            {fields.invoicedetails_address()}
          </div>

          {fields.invoicedetails_extra()}

          <article className={style.helptext}>
            {"De factuurinfo zetten we op emails waar een betaling aan vasthangt en op de factuur zelf."}
          </article>
        </div>
      ),
    });
  return (
    <div>
      <section>{form.render()}</section>
      <div style="text-align: right">
        {renderSaveButton({
          formS: form.s,
          save: (values) =>
            rpc(routes.saveSchoolConfigSpec, undefined, {
              ...values,
              schoolhours: [values.schoolhours_start, values.schoolhours_end],
              invoicedetails: {
                vat: values.invoicedetails_vat.trim() || null,
                address: values.invoicedetails_address.trim() || null,
                extra: values.invoicedetails_extra.trim() || null,
              },
            }),
          reload: true,
        })}
      </div>
    </div>
  );
}
